module.exports = __webpack_public_path__ + "img/3.37ce2ae0.png";